import React, { useEffect, useRef } from 'react';

function cleanupChartData(data) {
  data = data.filter(d => d.total_amount < 0);

  if (data.length > 8) {
    const remainder = data.slice(8);
    const remainder_total = remainder.reduce((acc, d) => acc + d.total_amount, 0);
    data = data.slice(0, 8);
    data.push({ name: "Other", total_amount: remainder_total });
  }

  return data;
}

export default function PieChart({ title, data = null, height = 300 }) {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  data = cleanupChartData(data);

  useEffect(() => {
    if (chartRef.current) {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }

      const chartData = {
        labels: data.map(d => d.name),
        datasets: [{
          data: data.map(d => d.total_amount),
        }]
      };

      const ctx = chartRef.current.getContext("2d");
      chartInstance.current = new window.Chart(ctx, {
        type: "pie",
        data: chartData,
        options: {
          maintainAspectRatio: false,
          responsive: true,
          legend: {
            position: 'bottom'
          }
        }
      });
    }
  }, [data, chartRef, chartInstance]);

  return (
    <div className={"mb-2 mt-2"}>
      <h6>{title}</h6>
      <div style={{ height }}>
        <canvas ref={chartRef} style={{ height: '100%' }}></canvas>
      </div>
    </div>
  );
}